import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    borderTop: '1px solid gray',
    paddingTop: 10,
    paddingBottom: 10
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 5
  },

  tableRowRoot: {
    // marginTop: 20
  }
}))
export default useStyles
